import { FC } from 'react'

import {
  NotificationDisplayTier,
  NotificationDisplayViolation,
} from '~/src/components/shared/Notification/constants'
import { Notification } from '~/src/components/shared/Notification/types'

type Props = {
  notification: Notification
}

const NotificationHeader: FC<Props> = ({ notification }) => {
  return (
    <div className="flex items-center justify-start space-x-2">
      <div className="text-body-m-emphasized">
        {NotificationDisplayViolation[notification.type]}
      </div>
      <div className="pt-1 text-label-xs uppercase text-secondary">
        {NotificationDisplayTier[notification.tier]}
      </div>
    </div>
  )
}

export default NotificationHeader
